import { NUDGES_ENDPOINT } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';

export function getNudgesForProduct(ids: string) {
  return typedHttp.get(replacePathParams(NUDGES_ENDPOINT, { ids }), {
    withAuth: true,
  });
}
